import React, { Component } from 'react';
import { connect } from 'react-redux';

import ListItem from 'subscriptions/ListItem';
import * as routes from 'app/routes';

class BypassedListItemComponent extends Component {
  render() {
    return <ListItem {...this.props} carrier="bypassed"/>
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  subRoute: routes.bypassedSubscription,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BypassedListItemComponent);